;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .controller('MarkImageController', MarkImageController)

  /* @ngInject */
  function MarkImageController ($scope) {
    $scope.points = []

    const api = {
      _addFixedPin,
      _notifyScope
    }
    this.getApi = () => api

    $scope.addFixedPin = function (e) {
      if ($scope.allowMarkup) {
        const img = $(e.target)
        const offset = img.offset()
        const fixedIconSize = 56
        const xMargin = fixedIconSize / 2
        const yMargin = fixedIconSize
        const x = (e.pageX - xMargin) - offset.left
        const y = (e.pageY + yMargin) - offset.top
        const position = { x, y }

        api._addFixedPin(position)
        api._notifyScope(position)
      }
    }

    function _addFixedPin (pin) {
      $scope.fixedPins.push(pin)
    }

    function _notifyScope (pin) {
      $scope.onMark({ pin })
    }
  }
})()
